export default {
  path: '/tune',
  title: '云微调',
  icon: 'shield',
  children: [
    {
      path: 'basic',
      title: '基本数据',
      icon: 'database',
      children: [
        {
          path: 'category',
          title: '品类管理',
          component: 'tune/basic/category'
        },
        {
          path: 'position',
          title: '品类部位',
          component: 'tune/basic/position'
        }
      ]
    },
    {
      path: 'order',
      title: '微调管理',
      icon: 'tasks',
      children: [
        {
          path: 'list',
          title: '微调订单',
          component: 'tune/order/list'
        }
      ]
    }
  ]
}
